import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  FormModeEnum,
  ModalService,
  BackendService,
  NotificationService,
  TableSettings,
  FieldMapItem,
  TableComponent,
  FilterComponent,
  TableActionEnum,
  ServiceFilterTerm,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';
import { EnumService } from '../../services/enum.service';
import { MediaPlanService } from '../../services/media-plan.service';

import * as moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '../../constants/date-format';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { flatMap } from 'rxjs/operators';
import { from } from 'rxjs/observable/from';
import { PregledRezervacijaTabEnum } from './enums/pregled-rezervacija-tab.enum';
import { resolve } from 'url';
import { pipe } from 'rxjs';

@Component({
  selector: 'app-rezervacije',
  templateUrl: './rezervacije.component.html',
})
export class RezervacijeComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;

  public BRENDIRANA_SPICA = 9;
  public showDetails = false;
  public spot: any;
  public ugovor: any;
  public ugovorZaZamenu: any;
  public podugovorZaZamenu: any;
  public podugovor: any;
  public selectStatuses = [0, 1];
  public allSelected = false;

  public spotLookupFieldSettings: FieldMapItem;
  public ugovorLookupFieldSettings: FieldMapItem;
  public klijentLookupFieldSettings: FieldMapItem;
  public obrisiEnabled: boolean;
  public initialLoad = true;
  public hardEditableColumnNames = ['SpotZeljenaPozicija'];
  public podugovoriKojiNemajuSpot: any[] = [];

  public activeTabEnum: PregledRezervacijaTabEnum;
  public activeTabSpot: PregledRezervacijaTabEnum;
  public activeTabUgovor: PregledRezervacijaTabEnum;

  private _tipoviUgovora: any[] = [];
  public datumOdFieldSettings: FieldMapItem;
  public datumDoFieldSettings: FieldMapItem;

  private filterComponent: FilterComponent;
  oldFilterQuery: string;

  public infoBarRezervacija: any;

  public get PregledRezervacijaTabEnum(): typeof PregledRezervacijaTabEnum {
    return PregledRezervacijaTabEnum;
  }

  private rezervacijeTableComponent: TableComponent;
  @ViewChild('rezervacijeTableComponent') set rezContent(
    content: TableComponent
  ) {
    if (content) {
      this.rezervacijeTableComponent = content;
    }
  }
  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _enumService: EnumService,
    private _rtsBackendService: RtsBackendService,
    private _mediaPlanService: MediaPlanService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
      this.subscribeToTipoviUgovora();
      this.setTabSpot(PregledRezervacijaTabEnum.Spot);
      this._enumService.fetchStatusUgovora();
      this._enumService.fetchTipoviUgovora();
      this._enumService.fetchVrstaZabrane();
      this._enumService.fetchVrstaSpota();
      this._enumService.fetchVrsteMedija();
      this._enumService.fetchProgrami();
      this._enumService.registerZeljenePozicije();
      this.getlookupSettigs();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Nova rezervacija';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Rezervacija';
    }
  }

  subscribeToTipoviUgovora() {
    this._subscriptions.push(
      this._enumService.tipoviUgovora$.subscribe(response => {
        this._tipoviUgovora = response;
      })
    );
  }

  checkDefaultPodugovor(ugovorId: any) {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSUGO_PUGKLI,
        FormName.Podugovor,
        EndpointTypes.AllEntities,
        `?ugovorId=${ugovorId}`
      )
      .subscribe(response => {
        if (response.ServiceData.Data.length === 1) {
          this.podugovorZaZamenu = response.ServiceData.Data[0];
        }
      });
  }

  getlookupSettigs() {
    const mediaPlanSettings = this._mediaPlanService.getMediaPlanUgovorSettings();
    const mediaPlanSettingsTable = new TableSettings(
      mediaPlanSettings,
      'table'
    );

    this.spotLookupFieldSettings = mediaPlanSettingsTable.getFieldByName(
      'Spot'
    );

    this.ugovorLookupFieldSettings = mediaPlanSettingsTable.getFieldByName(
      'Ugovor'
    )

    this.klijentLookupFieldSettings = mediaPlanSettingsTable.getFieldByName(
      'Klijent'
    )
  }

  setTabSpot(tab: PregledRezervacijaTabEnum) {
    if (this.activeTabSpot == null || this.activeTabSpot != tab){
      this.allSelected = false;
      this.activeTabSpot = tab;
      this.activeTabUgovor = null;
      this.selectStatuses = [0, 1];
      if (this.initialLoad === false) {
        this.loadSettings();
      }
    }
  }

  setTabUgovor(tab: PregledRezervacijaTabEnum) {
    if (this.activeTabUgovor == null || this.activeTabUgovor != tab){
      this.allSelected = false;
      this.activeTabUgovor = tab;
      this.activeTabSpot = null;
      this.selectStatuses = [0, 1, 2, 3];
      if (this.initialLoad === false) {
        this.loadSettings();
      }
    }
  }

  onSpotChange(event: any) {
    this.spot = event.value;
  }

  onUgovorChange(event: any) {
    if(event.value === null) {
      this.ugovorZaZamenu = null;
      this.podugovorZaZamenu = null;
    }
    if(!this.ugovorZaZamenu) {
      this.ugovorZaZamenu = event.value;
      this.podugovorZaZamenu = null;
    }
    else if(event.value !== null && this.ugovorZaZamenu.Id !== event.value.Id) {
      this.ugovorZaZamenu = event.value;
      this.podugovorZaZamenu = null;
    }
    if(this.ugovorZaZamenu) {
      this.klijentLookupFieldSettings.lookupInitFilter = [
        { name: 'ugovorId', value: this.ugovorZaZamenu.Id },
      ];
      this.checkDefaultPodugovor(this.ugovorZaZamenu.Id);
    }
  }

  onPodugovorChange(event: any) {
    if(this.ugovorZaZamenu) {
      this.podugovorZaZamenu = event.value;
    } else{
      this._notificationService.notifyError('Niste izabrali ugovor.');
    }
  }

  onAllSelected(allSelected: any) {
    this.allSelected = allSelected;

    if(this.activeTabUgovor === PregledRezervacijaTabEnum.Ugovor) {
      this.orderList.forEach(r => {
        if (r.Status === 0 || r.Status === 1 || r.Status === 2 || r.Status === 3) {
          r.selected = allSelected;
        }
      });  
    }
    else{
      this.orderList.forEach(r => {
        if (r.Status === 0 || r.Status === 1) {
          r.selected = allSelected;
        }
      });
    }

    this.obrisiEnabled = this.orderList.some(s => s.selected);
  }

  onRowSelected(selected: any) {
    if (this.allSelected && selected !== this.allSelected) {
      this.allSelected = !this.allSelected;
    }

    const selectedRows = this.getSelectedObjects();
    this.obrisiEnabled =
      selectedRows.length &&
      !selectedRows.some(
        x => x.Status === 2 || x.Status === 4 || x.Status === 3
      );
  }

  onRowClick(row: any) {
    if (row != undefined && row.srcElement != undefined && row.srcElement.dataset != undefined && row.srcElement.dataset.dataId != undefined) {
      const rez: any = this.orderList.filter(a => a.Id === row.srcElement.dataset.dataId);
      this.infoBarRezervacija = rez[0];
    } else if (row != undefined && row.srcElement != undefined && row.srcElement.dataset != undefined && row.srcElement.dataset.dataRbr != undefined) {
      const rez: any = this.orderList.filter(a => a.Id === row.srcElement.dataset.dataRbr);
      this.infoBarRezervacija = rez[0];
    } else if (row != undefined && row.srcElement != undefined && row.srcElement.children != undefined && row.srcElement.children.length > 0 && row.srcElement.children[0].children != undefined && row.srcElement.children[0].children.length > 0 &&
      row.srcElement.children[0].children[0].dataset != undefined && row.srcElement.children[0].children[0].dataset.dataId != undefined) {
      const rez: any = this.orderList.filter(a => a.Id === row.srcElement.children[0].children[0].dataset.dataId);
      this.infoBarRezervacija = rez[0];
    }
  }

  modalCallPrebacivanjeRezervacija(podugovori: any[]) {
    const podugovorString = podugovori.length > 1 ? 'podugovorima' : 'podugovoru';
    let podugovoriKojiNemajuSpotArray = [];

    for(let i = 0; i < podugovori.length; i++) {
      this.podugovoriKojiNemajuSpot.push({Id: podugovori[i].Id});
      podugovoriKojiNemajuSpotArray.push(podugovori[i].BrojPodugovora);
    }
    
    let podugovoriKojiNemajuSpot = podugovoriKojiNemajuSpotArray.join(', ');

    return new Promise((resolve, reject) => {
      if (podugovori.length) {
        this._modalService.openModal(
          [
            `Spotovi sa rezervacija koje se prebacuju na podugovor: ${this.podugovorZaZamenu.BrojPodugovora} koji nisu uključeni na tom podugovoru će biti automatski dodati na selektovani podugovor. Da li ste sigurni da želite da nastavite?`,
            `(Napomena: Prilikom odustajanja, zamena neće biti izvršena ni za jednu selektovanu rezervaciju.)`,
          ],
          confirmed => {
            if(!confirmed) {
              this.podugovoriKojiNemajuSpot = [];
            }
            resolve(confirmed);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  modalCallZamenaBrendiraneSpice(podugovori: any[], vrstaSpotaId) {
      return new Promise((resolve, reject) => {
        if(vrstaSpotaId === this.BRENDIRANA_SPICA) {
          this._modalService.openModal(
            [
              `Brendirane špice u svim blokovima u montaži će biti zamenjene u emisijama kojima pripadaju za selektovane datume. Da li želite da nastavite?`,
              `(Napomena: Prilikom odustajanja, zamena neće biti izvršena ni za jednu selektovanu rezervaciju.)`,
            ],
            (confirmed) => {
              if(!confirmed) {
                this.podugovoriKojiNemajuSpot = [];
              }
              resolve(confirmed);
            }
          )
        }
        else {
          resolve(true);
        };
    }
    );
  }

  modalCall(podugovori: any[]) {
    if(this.activeTabUgovor === PregledRezervacijaTabEnum.Ugovor) {
      const podugovorString = podugovori.length > 1 ? 'podugovorima' : 'podugovoru';
      let podugovoriKojiNemajuSpotArray = [];

      for(let i = 0; i < podugovori.length; i++) {
        this.podugovoriKojiNemajuSpot.push({Id: podugovori[i].Id});
        podugovoriKojiNemajuSpotArray.push(podugovori[i].BrojPodugovora);
      }
      
      let podugovoriKojiNemajuSpot = podugovoriKojiNemajuSpotArray.join(', ');

      return new Promise((resolve, reject) => {
        if (podugovori.length) {
          this._modalService.openModal(
            [
              `Spotovi sa rezervacija koje se prebacuju na podugovor: ${this.podugovorZaZamenu.BrojPodugovora} koji nisu uključeni na tom podugovoru će biti automatski dodati na selektovani podugovor. Da li ste sigurni da želite da nastavite?`,
              `(Napomena: Prilikom odustajanja, zamena neće biti izvršena ni za jednu selektovanu rezervaciju.)`,
            ],
            confirmed => {
              if(!confirmed) {
                this.podugovoriKojiNemajuSpot = [];
              }
              resolve(confirmed);
            }
          );
        } else {
          resolve(true);
        }
      });
    }
    else {
      const podugovorString = podugovori.length > 1 ? 'podugovorima' : 'podugovoru';
      let podugovoriKojiNemajuSpotArray = [];
      let BRENDIRANA_SPICA = 9;

      for(let i = 0; i < podugovori.length; i++) {
        this.podugovoriKojiNemajuSpot.push({Id: podugovori[i].Id});
        podugovoriKojiNemajuSpotArray.push(podugovori[i].BrojPodugovora);
      }
      
      let podugovoriKojiNemajuSpot = podugovoriKojiNemajuSpotArray.join(', ');

      return new Promise((resolve, reject) => {
        if (podugovori.length && this.spot.VrstaSpotaId != BRENDIRANA_SPICA) {
          this._modalService.openModal(
            [
              `Spot sa kojim se vrši zamena nije uključen na ${podugovorString}: ${podugovoriKojiNemajuSpot}. Ovaj spot će biti automatski dodat na dati podugovor. Da li ste sigurni da želite da nastavite?`,
              `(Napomena: Prilikom odustajanja, zamena neće biti izvršena ni za jednu selektovanu rezervaciju.)`,
            ],
            confirmed => {
              if(!confirmed) {
                this.podugovoriKojiNemajuSpot = [];
              }
              resolve(confirmed);
            }
          );
        } else {
          resolve(true);
        }
      });
    }
  }

  update() {
    const selected = this.orderList.filter(d => d.selected);
    const rezIds = selected.map(d => d.Id);
    
    const podugovorIds = selected.map(d => d.PodugovorId);

    if(this.activeTabUgovor === PregledRezervacijaTabEnum.Ugovor) {
      if (!this.ugovorZaZamenu || !this.podugovorZaZamenu || !rezIds.length) {
        this.notifyError('Niste izabrali potrebne podatke.');
  
        return;
      }
      
      const selectedRezSpotIds = selected.map(d => d.SpotId);
      const selectedRezSpotNazivi = selected.map(d => d.SpotNaziv);
      const selectedRezSpotZeljenePozicije = selected.map(d => d.SpotZeljenaPozicija);
      const selectedVrstaSpotaIds = selected.map(d => d.VrstaSpotaId);
      const selectedVrsteSpota = selected.map(d => d.VrstaSpota);
      const spotovi = [];

      for(let i = 0; i < selectedRezSpotIds.length; i++) {
        spotovi.push({
          Id: selectedRezSpotIds[i],
          Naziv: selectedRezSpotNazivi[i],
          ZeljenaPozicija: selectedRezSpotZeljenePozicije[i],
          VrstaSpotaId: selectedVrstaSpotaIds[i],
          VrstaSpota: selectedVrsteSpota[i]
        });
      }

      this._spinner.show();
  
      this.proveriPostojanjeSpotaNaPodugovorima([this.podugovorZaZamenu.PodugovorId])
        .pipe(
          // poziva modal ciji je rezultat wrap-ovan u promise, promis se sa 'from' konvertuje u observable.
          flatMap((res: any) => from(this.modalCallPrebacivanjeRezervacija(res.ServiceData))),
          // ako je rezultat modala - DA - ide se na proveru ka serveru - da li postoji cena za sponzorstvo na ovom spotu.
          // Ako je rezultat modala - NE - return of(null) ovde, kako bi odma skocio na subscribe i ne bi nastavljao dalje.
          // Ukoliko servis ne vrati error -> subs
          flatMap((modalResponse: boolean) =>
            this.handleSponzorstvoCheck(modalResponse, null, rezIds)
          ),
          flatMap((res: any) => this.handlePrebaciRezervacijeNaDrugiUgovorPodugovor(res, rezIds, spotovi))
        )
        .subscribe(
          response => {
            if (this.hasError(response)) {
              this.notifyError(response['Errors'][0]['ErrorMessage']);
            }
  
            // response

            this._spinner.hide();
            this.unselectAll();
            this.spot = null;
            if(response.ServiceData.SifreSpecifikacija.length > 0) {
              this._notificationService.openNoty(`Treba obrisati specifikacije emitovanja sa šiframa: ${response.ServiceData.SifreSpecifikacija.join(', ')}`);
            }
            this.loadSettings();
          },
          error => this._spinner.hide()
        );
    }
    else if(this.activeTabSpot === PregledRezervacijaTabEnum.Spot) {
      if (!this.spot || !rezIds.length) {
        this.notifyError('Niste izabrali potrebne podatke.');
  
        return;
      }

      if(this.spot && this.spot.VrstaSpotaId === this.BRENDIRANA_SPICA) {
        this._spinner.show();
      
        let spotoviKojiNisuBSpica = selected.filter(d => d.VrstaSpotaId !== this.BRENDIRANA_SPICA);
        if(spotoviKojiNisuBSpica.length > 0) {
          this.notifyError('Brendirana špica se ne može koristiti za zamenu.');
          this._spinner.hide();
          
        return;
        }
        else {
          this.proveriPostojanjeSpotaNaPodugovorima(podugovorIds).
          pipe(
            flatMap((res: any) => from(this.modalCallZamenaBrendiraneSpice(res.ServiceData, this.spot.VrstaSpotaId))),
          // ako je rezultat modala - DA - ide se na proveru ka serveru - da li postoji cena za sponzorstvo na ovom spotu.
          // Ako je rezultat modala - NE - return of(null) ovde, kako bi odma skocio na subscribe i ne bi nastavljao dalje.
          // Ukoliko servis ne vrati error -> subs
          flatMap((modalResponse: boolean) =>
            this.handleSponzorstvoCheck(modalResponse, podugovorIds, null)
          ),
          flatMap((res: any) => this.handleBulkUpdate(res, rezIds, this.podugovoriKojiNemajuSpot))
          ).subscribe(
            response => {
              if (this.hasError(response)) {
                this.notifyError(response['Errors'][0]['ErrorMessage']);
              }
    
              this._spinner.hide();
              this.unselectAll();
              this.spot = null;
              this.loadSettings();
              this.podugovoriKojiNemajuSpot = [];
            },
            error => this._spinner.hide()
          );
        }
      }
      else {
        this._spinner.show();
  
        if(this.spot.VrstaSpotaId !== this.BRENDIRANA_SPICA) {
          let brendiraneSpice = selected.filter(d => d.VrstaSpotaId === this.BRENDIRANA_SPICA);
          if(brendiraneSpice.length > 0) {
            this.notifyError('Brendirana špica se može zameniti samo sa brendiranom špicom.');
            this._spinner.hide();
            
            return;
          }
        }
        this.proveriPostojanjeSpotaNaPodugovorima(podugovorIds)
        .pipe(
          // poziva modal ciji je rezultat wrap-ovan u promise, promis se sa 'from' konvertuje u observable.
          flatMap((res: any) => from(this.modalCall(res.ServiceData))),
          // ako je rezultat modala - DA - ide se na proveru ka serveru - da li postoji cena za sponzorstvo na ovom spotu.
          // Ako je rezultat modala - NE - return of(null) ovde, kako bi odma skocio na subscribe i ne bi nastavljao dalje.
          // Ukoliko servis ne vrati error -> subs
          flatMap((modalResponse: boolean) =>
            this.handleSponzorstvoCheck(modalResponse, podugovorIds, null)
          ),
          flatMap((res: any) => this.handleBulkUpdate(res, rezIds, this.podugovoriKojiNemajuSpot))
        )
        .subscribe(
          response => {
            if (this.hasError(response)) {
              this.notifyError(response['Errors'][0]['ErrorMessage']);
            }
  
            this._spinner.hide();
            this.unselectAll();
            this.spot = null;
            this.loadSettings();
            this.podugovoriKojiNemajuSpot = [];
          },
          error => this._spinner.hide()
        );
      }
    }
  }
    
    

  loadSettings() {
    // const defaultFilter = [
    //   {
    //     key: 'DatumOd',
    //     value: moment().day('Monday'),
    //   },
    //   {
    //     key: 'DatumDo',
    //     value: moment().day(7),
    //   },
    // ];

    this.oldFilterQuery = `${this.filterQuery}`;

    // dodati na filterquery samo ako je prvi load
    // if (this.initialLoad) {
    //   defaultFilter.forEach(filt => {
    //     this.filterQuery += `&${filt.key}=${filt.value.format(
    //       DEFAULT_DATE_FORMAT
    //     )}`;
    //   });
    // }

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_REZ,
      FormName.MediaPlan,
      this.initialLoad === true ? EndpointTypes.GetModelData : EndpointTypes.GetAllEntities,
      this.filterQuery
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (this.hasError(response)) {
            this.notifyError(response['Errors'][0]['ErrorMessage']);

            return;
          }

          if (!this.settingsTable) {
            const settings = this.alterSettings(response);
            this.setSettings(settings);

            // defaultFilter.forEach(filt => {
            //   const field = this.settingsFilter.fieldList.find(
            //     f => f.fieldKey === filt.key
            //   );
            //   field.value = filt.value;

            //   if (
            //     this._lastUsedFilter.filterObjects.every(f => f.id !== field.id)
            //   ) {
            //     this._lastUsedFilter.filterObjects.push(field);
            //   }
            // });
          }

          this.oldFilterQuery = this.filterQuery;
          this._data = response.ServiceData.Data;
          this._dataCount = response.ServiceData.DataSumCount;

          if (this._data && this._data.length) {
            this.setColorForRezervacijeInMontaza();
          }

          this.setAllFields();
          this.refreshTable();
          this.changeMode(FormModeEnum.Table);
        })
    );
  }

  hasError(response: any) {
    return (
      response['Errors'] &&
      response['Errors'].length &&
      response['Errors'][0]['ErrorMessage']
    );
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    this.initialLoad = false;
    super.onTableActionFilter(event);
  }

  setColorForRezervacijeInMontaza() {
    this._data.forEach(r => {
      switch (r.Status) {
        case 1:
          r.color = 'warning';
          break;
        case 2:
          r.color = 'danger';
          break;
        case 3:
          r.color = 'verified';
          break;
        case 4:
          r.color = 'info';
          break;
      }
    });
  }

  alterSettings(data: any) {
    const settings = { ...data.Settings };
    const rbrField = (<any[]>data.Settings.allFields).find(
      x => x.fieldKey === 'RedniBroj'
    );

    settings.allFields
      .filter(f => f.fieldKey !== 'SpotZeljenaPozicija')
      .forEach(ff => (ff.editable = false));

    rbrField.width = 1;

    settings.inlineEditing = true;
    settings.inlineAdding = true;
    settings.additable = false;
    settings.deletable = false;
    settings.editable = true;

    return settings;
  }

  refreshTable() {
    this._data.forEach(d => (d['id'] = d.Id));
    this._data.forEach(d => (d['rbr'] = d.Id));

    this.orderList = this._data;
    if(this.activeTabSpot === PregledRezervacijaTabEnum.Spot) {
      for(let i = 0; i < this.orderList.length; i++) {
        if(this.orderList[i].VrstaSpotaId == 9) {
          this.orderList[i].Status = null;
        }
      }
    }
    this.orderListCount = this._dataCount;
  }

  getSelectedObjects() {
    const selected = this.orderList.filter(x => x.selected);

    return selected;
  }

  obrisi() {
    const selected = this.getSelectedObjects();
    if (this.orderList && selected.length) {
      const toDelete = selected
        .filter(r => r.Status === 0 || r.Status === 1)
        .map(x => x.Id);
      const payload = this._rtsBackendService.getRequestPayload(
        FormCode.MSMP_DREZR,
        FormName.MediaPlan,
        EndpointTypes.PostEntity,
        null,
        toDelete,
        null,
        true
      );

      this._subscriptions.push(
        this._rtsBackendService
          .fetchMediaPlanSettings(payload)
          .subscribe((response: any) => {
            if (this.hasError(response)) {
              this.unselectAll();

              return this.notifyError(response['Errors'][0]['ErrorMessage']);
            }

            this.unselectAll();
            this.loadSettings();
          })
      );
    }
  }

  unselectAll() {
    this.orderList.forEach(r => (r.selected = false));
    this.obrisiEnabled = false;
    this.allSelected = false;
  }

  rezervacijeTableAction(event, isFilter: boolean) {
    switch (event.action) {
      case TableActionEnum.Select:
        this.onSelect(event);
        break;

      case TableActionEnum.Filter:
        event.isFilterEvent = isFilter;
        this.onTableActionFilter(event);
        this.unselectAll();
        break;

      case TableActionEnum.Edit:
        this._orderBeforeEditing = { ...this.order };
        this._subscriptions.push(
          this.validateRezervacija(event.document).subscribe(valid => {
            if (this.hasError(valid)) {
              event.document.cantUpdateMessage =
                valid['Errors'][0]['ErrorMessage'];
            } else {
              event.document.cantUpdateMessage = null;
            }
          })
        );

        break;
      case TableActionEnum.EditCancel:
        this.copyProperties(this._orderBeforeEditing, this.order);
        break;
      case TableActionEnum.BeforeSave:
        break;

      case TableActionEnum.Update:
        this._spinner.show();
        super.onTableActionUpdate(event);
        this._subscriptions.push(
          this.checkExistenceOfUvecanjeZeljenaPozicija(
            event.document.PodugovorId,
            event.document.SpotZeljenaPozicija
          ).subscribe((result: any) => {
            if (result && !result.ServiceData) {
              this.notify(
                'Korekcija za željenu poziciju ne postoji na podugovoru. Rezervacija će biti izmenjena.'
              );
            }

            this.updateRezervacijaObs(event.document).subscribe(
              res => {
                const serviceData = res.ServiceData;
                if (serviceData != null && serviceData.Success) {
                  this._spinner.hide();
                  this.notify(
                    'Uspešno ažurirana željena pozicija rezervacije.'
                  );
                  if (serviceData.Iznos != null) {
                    event.document.IznosSaKorekcijamaRSD = serviceData.Iznos;
                    event.document.DatumIzmene = serviceData.DatumIzmene;
                    event.document.IzmenioImePrezime = serviceData.IzmenioImePrezime;
                    event.document.PoslednjaAkcija = 'Promena željene pozicije u bloku';
                  }
                  this.rezervacijeTableComponent.inlineUpdateOrAddOrder(event);
                } else {
                  this._spinner.hide();
                  this.notifyError(
                    'Desila se greška prilikom ažuriranja željene pozicije rezervacije.'
                  );
                  this._spinner.hide();
                }
              },
              error => {
                this._spinner.hide();
                this.notifyError(
                  'Desila se greška prilikom ažuriranja željene pozicije rezervacije.'
                );
              }
            );
          })
        );
        break;
    }
  }

  updateRezervacijaObs(order): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_RAPUB,
      FormName.MediaPlan,
      EndpointTypes.PutEntity,
      null,
      order,
      true,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  validateRezervacija(order): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_VALREZ,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      null,
      order,
      true,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  checkExistenceOfUvecanjeZeljenaPozicija(
    podugovorId: string,
    zeljenaPozicija: string
  ): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSUGO_PKUUB,
      FormName.MediaPlan,
      EndpointTypes.GetSingleEntity,
      `?podugovorId=${podugovorId}&zeljenaPozicijaUBloku=${zeljenaPozicija}`,
      null,
      true,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  proveriPostojanjeSpotaNaPodugovorima(podugovorIds: any[]): Observable<any> {
    const distinctIds: Set<any> = new Set<string>(
      podugovorIds && podugovorIds.length > 0 ? podugovorIds : []
    );

    if(this.activeTabUgovor === PregledRezervacijaTabEnum.Ugovor) {
      const selected = this.orderList.filter(d => d.selected);
      let spotIds = selected.map(d => d.SpotId);;
      let entity = {
        spotIds: spotIds,
        podugovorIds: Array.from(distinctIds),
        akcija: PregledRezervacijaTabEnum.Ugovor
      }
      const payload = this._rtsBackendService.getRequestPayload(
        FormCode.MSUGO_PSPO,
        FormName.PregledUgovora,
        EndpointTypes.PostEntity,
        null,
        entity,
        null,
        true
      );
      return this._rtsBackendService.fetchMediaPlanSettings(payload)
    }
    else {
      let entity = {
        spotIds: new Array(this.spot.Id),
        podugovorIds: Array.from(distinctIds),
        akcija: PregledRezervacijaTabEnum.Spot
      }

      const payload = this._rtsBackendService.getRequestPayload(
        FormCode.MSUGO_PSPO,
        FormName.PregledUgovora,
        EndpointTypes.PostEntity,
        null,
        entity,
        null,
        true
      );
      return this._rtsBackendService.fetchMediaPlanSettings(payload)
    }
  }

  prebaciRezervacijeNaDrugiUgovorPodugovor(rezIds: any[], spotovi: any[]): Observable<any> {
    const entity = {
      UgovorId: this.ugovorZaZamenu.Id,
      BrojUgovora: this.ugovorZaZamenu.BrojUgovora,
      PodugovorId: this.podugovorZaZamenu.PodugovorId,
      PodugovorDatumKreiranja: moment(this.podugovorZaZamenu.DatumKreiranja).format('YYYY-MM-DD'),
      PodugovorDatumIsteka: moment(this.podugovorZaZamenu.DatumIsteka).format('YYYY-MM-DD'),
      BrojPodugovora: this.podugovorZaZamenu.BrojPodugovora,
      NacinObracunaId: this.podugovorZaZamenu.NacinObracunaId,
      BrojPlaniranihRezervacija: this.podugovorZaZamenu.BrojPlaniranihRezervacija,
      rezIds,
      spotovi,
    }

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_RNP,
      FormName.MediaPlan,
      EndpointTypes.PutEntity,
      null,
      entity,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);;
  }

  bulkUpdateSpot(rezIds: any[], podugovoriKojiNemajuSpot: any[] ): Observable<any>  {
    let jeSpica = this.spot.VrstaSpotaId === 9 ? true : false;

    const entity = {
      rezIds,
      podugovoriKojiNemajuSpot,
      JeSpica: jeSpica,
      PodugovorId: this.spot.PodugovorId,
      BrojPodugovora: this.spot.BrojPodugovora,
      SpotId: this.spot.Id,
      SpotNaziv: this.spot.Naziv,
      SpotSifra: this.spot.Sifra,
      SpotTrajanje: this.spot.TrajanjeSekunde,
      SpotDatumKreiranja: this.spot.DatumKreiranja,
      DatumPrijema: this.spot.DatumPrijema,
      DatumOdjave: this.spot.DatumOdjave,
      VremeTrajanjaServer: this.spot.VremeTrajanjaServer,
      VrstaSpotaId: this.spot.VrstaSpotaId,
      VrstaSpota: this.spot.VrstaSpota,
      ZeljenaPozicija: this.spot.ZeljenaPozicija,
      JePrisutanNaVideoServeru: this.spot.JePrisutanNaVideoServeru
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_BUR,
      FormName.MediaPlan,
      EndpointTypes.PutEntity,
      null,
      entity,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  checkVrsteSpotaNaPodugovorSponzorstvo(podugovor, rezIds): Observable<any> {
    let VrsteSpotova = [];
    for (let i = 0; i < this._data.length; i++) {
      for(let j = 0; j < rezIds.length; j++) {
        if(this._data[i].Id === rezIds[j]) {
          VrsteSpotova.push({ Id: this._data[i].VrstaSpotaId, Naziv: this._data[i].VrstaSpota });
        }
      }
    }

    let entity = {
      Podugovor: podugovor,
      VrsteSpotova: VrsteSpotova
    }

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSUGO_PVSSPON,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      null,
      entity,
      null,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  checkSponzrostvoCenaPodugovorSpot(podugovorIds: any[]): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_PCSPON,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      `?vrstaSpotaId=${
        this.spot.VrstaSpotaId
      }&nazivVrsteSpota=${encodeURIComponent(this.spot.VrstaSpota)}`,
      podugovorIds,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  handleSponzorstvoCheck(
    modalResponse: boolean,
    podugovorIds: any[],
    rezIds: any[]
  ): Observable<any> {
    let sponzorstvo = 4;
    if (modalResponse) {
      if(this.activeTabUgovor === PregledRezervacijaTabEnum.Ugovor) {
        //if(this.podugovorZaZamenu.NacinObracunaId === sponzorstvo) {
          return this.checkVrsteSpotaNaPodugovorSponzorstvo({ Id: this.podugovorZaZamenu, Naziv: this.podugovorZaZamenu.BrojPodugovora }, rezIds);
        //}
      }
      else {
        return this.checkSponzrostvoCenaPodugovorSpot(podugovorIds);
      }
    } else {
      return of(null);
    }
  }

  handleBulkUpdate(serviceRespose: any, rezIds: any[], podugovoriKojiNemajuSpot: any[]): Observable<any> {
    if (this.hasError(serviceRespose)) {
      return of(serviceRespose);
    } else {
      return this.bulkUpdateSpot(rezIds, podugovoriKojiNemajuSpot);
    }
  }

  handlePrebaciRezervacijeNaDrugiUgovorPodugovor(serviceRespose: any, rezIds: any[], spotovi: any[]): Observable<any> {
    if (this.hasError(serviceRespose)) {
      return of(serviceRespose);
    } else {
      return this.prebaciRezervacijeNaDrugiUgovorPodugovor(rezIds, spotovi);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rezervacije/rezervacije.component.ts